import { buildFilterOptionsAction } from "features/Application/actions/actionsBuilder";
import ReducerNamespaceTypes from "enums/reducer/reducerNamespaceTypes";
import ReducerEntityPrefixTypes from "enums/reducer/reducerEntityPrefixTypes";

export const PEOPLE_GROUPS_ENROLLMENT_FILTER_OPTIONS = buildFilterOptionsAction(
  ReducerNamespaceTypes.People,
  ReducerEntityPrefixTypes.Groups,
  "EnrollmentFilters",
);
